import { toastError, toastSuccess } from "../../../components/Utility/ToastUtils";
import * as COUPON from "../../actions/Coupon/Coupon.actions";

const initialState = {
  coupons: null,
  couponsObj: null,
  loading: false,
  error: null,
};

export const couponReducer = (state = initialState, action) => {
  switch (action.type) {
    case COUPON.COUPON_ADD:
      return {
        ...state,
        loading: true,
      };
    case COUPON.COUPON_ADD_SUCCESS:
      toastSuccess(action.payload);

      return {
        ...state,
        loading: false,
      };
    case COUPON.COUPON_ADD_FAIL:
      toastError(action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case COUPON.GET_ALL_COUPON:
      return {
        ...state,
        loading: true,
      };
    case COUPON.GET_ALL_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        coupons: action.payload.data,
      };
    case COUPON.GET_ALL_COUPON_FAIL:
      toastError(action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case COUPON.DELETE_COUPON_BY_ID:
      return {
        ...state,
        loading: true,
      };
    case COUPON.DELETE_COUPON_BY_ID_SUCCESS:
      toastSuccess(action.payload.message);
      return {
        ...state,
        loading: false,
        error: null,
      };
    case COUPON.DELETE_COUPON_BY_ID_FAIL:
      toastError(action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case COUPON.UPDATE_COUPON_BY_ID:
      return {
        ...state,
        loading: true,
      };
    case COUPON.UPDATE_COUPON_BY_ID_SUCCESS:
      toastSuccess(action.payload);
      return {
        ...state,
        loading: false,
        error: null,
      };
    case COUPON.UPDATE_COUPON_BY_ID_FAIL:
      toastError(action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case COUPON.SET_COUPON_OBJ:
      return {
        ...state,
        loading: true,
      };
    case COUPON.SET_COUPON_OBJ_SUCCESS:
      toastSuccess(action.payload.message);
      return {
        ...state,
        couponsObj: action.payload.data,
        loading: false,
        error: null,
      };
    case COUPON.SET_COUPON_OBJ_FAIL:
      toastError(action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
